import { CodeName } from '@heda/core-util';

export class ObservationGroupDefinition {
  public id?: number;
  public definition?: CodeName;
  public priority?: number;
  public ageGroups?: string[];
}

export class ObservationGroup extends CodeName {
  public definitions?: ObservationGroupDefinition[];
}
